module.exports = __webpack_public_path__ + "static/cer_dor_9-be42c1abeb4ce0905767b20ff909c763.jpg";